import "./index.scss";

interface IProps {
  theme: "light" | "dark";
}

export const PlusIcon = ({ theme }: IProps) => {
  return (
    <div className="plus-icon-wrapper">
      {theme === "light" ? (
        <svg
          width="23"
          height="22"
          viewBox="0 0 23 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.5 0C5.42339 0 0.5 4.92339 0.5 11C0.5 17.0766 5.42339 22 11.5 22C17.5766 22 22.5 17.0766 22.5 11C22.5 4.92339 17.5766 0 11.5 0ZM17.8871 12.2419C17.8871 12.5347 17.6476 12.7742 17.3548 12.7742H13.2742V16.8548C13.2742 17.1476 13.0347 17.3871 12.7419 17.3871H10.2581C9.96532 17.3871 9.72581 17.1476 9.72581 16.8548V12.7742H5.64516C5.35242 12.7742 5.1129 12.5347 5.1129 12.2419V9.75807C5.1129 9.46532 5.35242 9.22581 5.64516 9.22581H9.72581V5.14516C9.72581 4.85242 9.96532 4.6129 10.2581 4.6129H12.7419C13.0347 4.6129 13.2742 4.85242 13.2742 5.14516V9.22581H17.3548C17.6476 9.22581 17.8871 9.46532 17.8871 9.75807V12.2419Z"
            fill="#113F59"
          />
        </svg>
      ) : (
        <svg
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11 0C4.92339 0 0 4.92339 0 11C0 17.0766 4.92339 22 11 22C17.0766 22 22 17.0766 22 11C22 4.92339 17.0766 0 11 0ZM17.3871 12.2419C17.3871 12.5347 17.1476 12.7742 16.8548 12.7742H12.7742V16.8548C12.7742 17.1476 12.5347 17.3871 12.2419 17.3871H9.75807C9.46532 17.3871 9.22581 17.1476 9.22581 16.8548V12.7742H5.14516C4.85242 12.7742 4.6129 12.5347 4.6129 12.2419V9.75807C4.6129 9.46532 4.85242 9.22581 5.14516 9.22581H9.22581V5.14516C9.22581 4.85242 9.46532 4.6129 9.75807 4.6129H12.2419C12.5347 4.6129 12.7742 4.85242 12.7742 5.14516V9.22581H16.8548C17.1476 9.22581 17.3871 9.46532 17.3871 9.75807V12.2419Z"
            fill="#329EE2"
          />
        </svg>
      )}
    </div>
  );
};
